export enum PRIVACY_LEVEL {
  ALLOW = 'allow',
  MASK = 'mask',
  HIDDEN = 'hidden',
  MASK_USER_INPUT = 'mask-user-input'
}

/**
 *
 * @see https://docs.datadoghq.com/real_user_monitoring/session_replay/browser/privacy_options/
 * @param privacyLevel
 */
const overrideSessionReplayPrivacyLevel = (privacyLevel: PRIVACY_LEVEL = PRIVACY_LEVEL.MASK) => ({
  'data-dd-privacy': privacyLevel
});
export default overrideSessionReplayPrivacyLevel;
